import styled from 'styled-components'
import { theme } from '~/styles'

interface StyledIconProps {
  backgroundColor?: string
  iconColor?: string | number
  outlinedSquare?: boolean
}

export const IconWrapper = styled.i<StyledIconProps>`
  width: ${({ outlinedSquare }) => (outlinedSquare ? '24px' : '50px')};
  height: ${({ outlinedSquare }) => (outlinedSquare ? '24px' : '50px')};
  border-radius: ${({ outlinedSquare }) => (outlinedSquare ? '6px' : '50%')};
  border: ${({ outlinedSquare, iconColor }) => (outlinedSquare ? `1px solid ${iconColor ?? 'blue'}` : 'none')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease-in;
  background-color: transparent;

  svg {
    transition: all ease 0.2s;
    fill: ${props => (props.iconColor ? props.iconColor : theme.colors.color378ff7)};
  }

  &:hover {
    background-color: ${props => (props.iconColor ? props.iconColor : theme.colors.color378ff7)};

    svg {
      fill: ${({ outlinedSquare, backgroundColor }) => (outlinedSquare ? 'white' : backgroundColor)};
    }
  }
`
